import { render, staticRenderFns } from "./DashboardQuotation.vue?vue&type=template&id=2f2754e2"
import script from "./DashboardQuotation.vue?vue&type=script&lang=js"
export * from "./DashboardQuotation.vue?vue&type=script&lang=js"
import style0 from "./DashboardQuotation.vue?vue&type=style&index=0&id=2f2754e2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports